module.exports = __webpack_public_path__ + "img/img-fa4b1b95.98b96673.png";